import React from 'react';
import * as styledComponents from './styles'
import CellImage from 'media/CellComplete.png';

const Home = React.forwardRef((props, ref) => {
  return (
    <styledComponents.HomeContainer ref={ref}>
      <styledComponents.CellImageUp src={CellImage} />
      <styledComponents.MainText>HOW TO DEFINE YOUR NEEDS SO YOU CAN HIRE A DEVELOPER OR OUTSOURCE?</styledComponents.MainText>
      <styledComponents.ServicesText>Tech Project Scoping</styledComponents.ServicesText>
      <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora?month=2021-01") }}>SCHEDULE A CALL</styledComponents.CallToAction>
      <styledComponents.CellImageDown src={CellImage} />
    </styledComponents.HomeContainer>
  );
});

export default Home;